// @ts-nocheck
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import Document from 'js/components/Document'
import FetchMore from 'js/components/FetchMore'
import { Container } from 'js/components/Grid'
import { H4 } from 'js/components/Heading'
import ToggleTranslation from 'js/components/Item/components/ToggleTranslation'
import LikeAndBookmark from 'js/components/LikeAndBookmark'
import Section from 'js/components/Section/Section'
import Spacer from 'js/components/Spacer/Spacer'
import TiptapView from 'js/components/Tiptap/TiptapView'
import { NotFound } from 'js/core/NotFound'
import ThemeProvider from 'js/theme/ThemeProvider'

import PodcastEpisodes from './components/PodcastEpisodes'
import PodcastMenu from './components/PodcastMenu'
import PodcastLinks from './helpers/podcastRoutes'
import { PODCAST_ITEM } from './Item.queries'

const Item = () => {
    const PAGE_SIZE = 10
    const { t } = useTranslation()
    const params = useParams()
    const { guid } = params

    const { loading, data, fetchMore } = useQuery<any>(PODCAST_ITEM, {
        variables: {
            guid,
            offset: 0,
            limit: PAGE_SIZE,
        },
        fetchPolicy: 'cache-and-network',
    })

    const [isTranslated, setIsTranslated] = useState(null)
    useEffect(() => {
        if (!loading && data?.entity) {
            setIsTranslated(!!data.entity.localTitle)
        }
    }, [loading, data])

    if (loading) {
        return null
    }
    if (!data?.entity) {
        return <NotFound />
    }

    const onEdit = PodcastLinks.PodcastEdit(guid, params)

    const { viewer, entity } = data
    const {
        localTitle,
        title,
        localRichDescription,
        richDescription,
        group,
        statusPublished,
        isTranslationEnabled,
    } = entity

    const hasTranslations = !!localRichDescription && isTranslationEnabled

    const translatedTitle = isTranslated ? localTitle : title
    const translatedRichDescription = isTranslated
        ? localRichDescription
        : richDescription

    const episodes = entity.episodes?.edges
    const isPublished = statusPublished === 'published'

    return (
        <ThemeProvider bodyColor="#FFFFFF">
            <Document title={translatedTitle} containerTitle={group?.name} />

            <Section backgroundColor="white" grow>
                <Container size="normal">
                    <Spacer
                        spacing="normal"
                        style={{
                            position: 'relative',
                        }}
                    >
                        <PodcastMenu
                            icon={entity.icon}
                            title={translatedTitle}
                            entity={entity}
                            onEdit={onEdit}
                            canCreate={entity.canEdit}
                        />

                        <TiptapView content={translatedRichDescription} />

                        {hasTranslations && (
                            <ToggleTranslation
                                isTranslated={isTranslated}
                                setIsTranslated={setIsTranslated}
                                style={{ marginTop: '12px' }}
                            />
                        )}

                        {isPublished && viewer.loggedIn && (
                            <LikeAndBookmark entity={entity} />
                        )}

                        <H4 as="h2">
                            {t('entity-podcast.episodes-quantity', {
                                count: data.entity.episodes.total,
                            })}
                        </H4>
                    </Spacer>

                    <FetchMore
                        edges={episodes}
                        getMoreResults={(data) => data.entity.episodes.edges}
                        fetchMore={fetchMore}
                        fetchCount={5}
                        maxLimit={data.entity.episodes.total}
                        resultsMessage={t('widget-podcast.result', {
                            count: 5,
                        })}
                    >
                        <PodcastEpisodes episodes={episodes} />
                    </FetchMore>
                </Container>
            </Section>
        </ThemeProvider>
    )
}

export default Item
